// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/campaigns/campaigns.css
// module id = 2050
// module chunks = 0